import type { EHRProvider } from '@heidi/schema/ml-scribe';

/** `@deprecated` Use IntegrationLaunchSource instead */
export enum IntegrationConnectionType {
  EHR_PROFILE_OLD = 'EHR_PROFILE_OLD',
  EHR_LAUNCH_PROFILE = 'EHR_LAUNCH_PROFILE',
  INTEGRATION_ONBOARDING_SESSION = 'INTEGRATION_ONBOARDING_SESSION',
}

export enum IntegrationLaunchSource {
  NONE = 'NONE',
  LEGACY_EHR_PROFILE = 'LEGACY_EHR_PROFILE',
  LEGACY_EPIC_FHIR_AUTH = 'LEGACY_EPIC_FHIR_AUTH',
  INTEGRATION_ONBOARDING_SESSION = 'INTEGRATION_ONBOARDING_SESSION',
  GENERIC_EHR_LAUNCH = 'GENERIC_EHR_LAUNCH',
}

// What the app's `useIntegrationEhrInfo` resolves; packages read it through the
// integrations data seam rather than importing the app hook.
export interface IntegrationEhrInfo {
  integrationConnectionType: IntegrationConnectionType | undefined;
  isIntegrationOnboardingSession: boolean;
  integrationLaunchSource: IntegrationLaunchSource;
  integrationEhrProvider: EHRProvider | undefined;
  integrationOnboardingSessionId: string | undefined;
  integrationOnboardingProvider: EHRProvider | undefined;
  integrationOnboardingCreatedAt: string | undefined;
  integrationOnboardingUpdatedAt: string | undefined;
  isPending: boolean;
  isLoading: boolean;
  isCapabilitiesPending: boolean;
  isCapabilitiesError: boolean;
  isError: boolean;
  isLoadingError: boolean;
  canSyncSchedule: boolean;
  canSyncNotes: boolean;
  canSyncSectionalNotes: boolean;
  canSyncDocuments: boolean;
  hasMultiple: boolean;
}
